import React, { useState } from "react";
import {
  Phone,
  Mail,
  Facebook,
  Linkedin,
  Youtube,
  ArrowRight,
} from "lucide-react";
import { LogoMark } from "./Logo";
import { footerLinks, bottomLinks } from "../mock";
import { useToast } from "../hooks/use-toast";

const XIcon = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.45-6.231zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77z" />
  </svg>
);

const InstagramIcon = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M12 2.2c3.2 0 3.6 0 4.9.1 1.2.1 1.8.2 2.2.4.6.2 1 .5 1.4.9.4.4.7.9.9 1.4.2.4.3 1 .4 2.2.1 1.3.1 1.7.1 4.9s0 3.6-.1 4.9c-.1 1.2-.2 1.8-.4 2.2-.2.6-.5 1-.9 1.4-.4.4-.9.7-1.4.9-.4.2-1 .3-2.2.4-1.3.1-1.7.1-4.9.1s-3.6 0-4.9-.1c-1.2-.1-1.8-.2-2.2-.4-.6-.2-1-.5-1.4-.9-.4-.4-.7-.9-.9-1.4-.2-.4-.3-1-.4-2.2C2.2 15.6 2.2 15.2 2.2 12s0-3.6.1-4.9c.1-1.2.2-1.8.4-2.2.2-.6.5-1 .9-1.4.4-.4.9-.7 1.4-.9.4-.2 1-.3 2.2-.4C8.4 2.2 8.8 2.2 12 2.2zm0 1.8c-3.1 0-3.5 0-4.7.1-1.1.1-1.7.2-2.1.4-.5.2-.9.5-1.3.9-.4.4-.6.8-.8 1.3-.1.4-.3 1-.4 2.1C2.6 9.9 2.6 10.3 2.6 12s0 2.1.1 3.3c.1 1.1.2 1.7.4 2.1.2.5.5.9.8 1.3.4.4.8.6 1.3.8.4.1 1 .3 2.1.4 1.2.1 1.6.1 4.7.1s3.5 0 4.7-.1c1.1-.1 1.7-.2 2.1-.4.5-.2.9-.5 1.3-.8.4-.4.6-.8.8-1.3.1-.4.3-1 .4-2.1.1-1.2.1-1.6.1-3.3s0-2.1-.1-3.3c-.1-1.1-.2-1.7-.4-2.1-.2-.5-.5-.9-.8-1.3-.4-.4-.8-.6-1.3-.8-.4-.2-1-.3-2.1-.4C15.5 4 15.1 4 12 4zm0 3.1c2.7 0 4.9 2.2 4.9 4.9s-2.2 4.9-4.9 4.9S7.1 14.7 7.1 12 9.3 7.1 12 7.1zm0 8.1c1.8 0 3.2-1.4 3.2-3.2s-1.4-3.2-3.2-3.2S8.8 10.2 8.8 12s1.4 3.2 3.2 3.2zm6.2-8.3c0 .6-.5 1.1-1.1 1.1s-1.1-.5-1.1-1.1.5-1.1 1.1-1.1 1.1.5 1.1 1.1z" />
  </svg>
);

const Footer = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const { toast } = useToast();

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email) return;
    toast({
      title: "Subscribed!",
      description: `Thanks ${name || "there"}, we'll be in touch.`,
    });
    setName("");
    setEmail("");
  };

  return (
    <footer className="px-4 md:px-8 pb-8">
      <div className="max-w-[1300px] mx-auto bg-[#6B7C61] rounded-[32px] p-5 md:p-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-[1fr_auto_auto_1fr] gap-10 lg:gap-8">
          {/* Left - Logo + Newsletter */}
          <div>
            {/* <LogoMark
              className="w-24 h-24 -ml-2"
              color="#FFFFFF"
            /> */}
            <img src="/EEBS_logo 1.png" alt="eebssolutions" className="w-[220px] h-auto -ml-2" />
            <p className="text-[15px] font-semibold text-white mt-8 mb-3">
              Subscribe to our newsletter
            </p>
            <form onSubmit={handleSubscribe} className="space-y-3 max-w-[320px]">
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="First name"
                className="w-full bg-white/20 backdrop-blur-sm placeholder-white/60 text-white px-4 py-3 rounded-xl outline-none focus:bg-white/30 focus:ring-2 focus:ring-white transition-all text-[14px]"
              />
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email address"
                className="w-full bg-white/20 backdrop-blur-sm placeholder-white/60 text-white px-4 py-3 rounded-xl outline-none focus:bg-white/30 focus:ring-2 focus:ring-white transition-all text-[14px]"
              />
              <button
                type="submit"
                className="w-full bg-[#2D6A4F] text-white py-3 rounded-xl font-medium hover:bg-[#3D8B6A] transition-colors"
              >
                Subscribe
              </button>
            </form>
          </div>

          {/* Middle - Quick Links */}
          <div className="md:pt-4">
            <h4 className="font-semibold text-white mb-5 text-[15px]">
              Quick Links
            </h4>
            <ul className="space-y-3">
              {footerLinks.map((l) => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    className="text-white/80 hover:text-white hover:underline underline-offset-4 text-[15px] transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Address */}
          <div className="md:pt-4">
            <h4 className="font-semibold text-white mb-5 text-[15px]">
              Registered Office
            </h4>
            <p className="text-white/80 text-[15px] leading-relaxed">
              34 Marlborough Park,<br />
              Kempston,<br />
              Bedford,<br />
              England, MK42 8AN
            </p>
          </div>

          {/* Right - Contact card */}
          <div>
            <div className="bg-[#0E0E10] text-white rounded-2xl p-6">
              <p className="text-sm text-gray-400 mb-3">Get in touch</p>
              <a
                href="tel:01245493832"
                className="flex items-center gap-2 text-[16px] mb-2 hover:text-[#2D6A4F] transition-colors"
              >
                <Phone className="w-4 h-4" />
                <span className="underline underline-offset-4">01245 493832</span>
              </a>
              <a
                href="mailto:compliance@eebssolutions.co.uk"
                className="flex items-center gap-2 text-[14px] md:text-[16px] mb-5 hover:text-[#2D6A4F] transition-colors"
              >
                <Mail className="w-4 h-4" />
                <span className="underline underline-offset-4">compliance@eebssolutions.co.uk</span>
              </a>
              <div className="flex gap-3">
                {[Facebook, XIcon, InstagramIcon, Linkedin, Youtube].map((Ic, i) => (
                  <a
                    key={i}
                    href="#"
                    aria-label="social"
                    className="w-8 h-8 rounded-md bg-[#1E1E22] hover:bg-[#2D6A4F] hover:text-white flex items-center justify-center text-white transition-colors"
                  >
                    <Ic className="w-4 h-4" />
                  </a>
                ))}
              </div>
            </div>

            {/* <button className="mt-4 w-full bg-[#0E0E10] text-white rounded-full py-3 px-6 flex items-center justify-between hover:bg-[#2D6A4F] transition-colors group">
              <span className="font-medium">eebssolutions Timesheet App</span>
              <span className="bg-[#2D6A4F] group-hover:bg-white group-hover:text-[#2D6A4F] text-white w-7 h-7 rounded-full flex items-center justify-center group-hover:translate-x-1 transition-all">
                <ArrowRight className="w-4 h-4" />
              </span>
            </button> */}
            <button className="mt-3 w-full bg-[#0E0E10] text-white rounded-full py-3 px-6 flex items-center justify-between hover:bg-[#2D6A4F] transition-colors group">
              <span className="font-medium">Register for CIS</span>
              <span className="bg-[#2D6A4F] group-hover:bg-white group-hover:text-[#2D6A4F] text-white w-7 h-7 rounded-full flex items-center justify-center group-hover:translate-x-1 transition-all">
                <ArrowRight className="w-4 h-4" />
              </span>
            </button>
          </div>
        </div>
      </div>

      <div className="max-w-[1300px] mx-auto mt-8 text-center">
        <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-[13px] text-[#4A4A4D] mb-3">
          {bottomLinks.map((l, i) => (
            <React.Fragment key={l}>
              <a href="#" className="hover:text-[#0E0E10] transition-colors">
                {l}
              </a>
              {i < bottomLinks.length - 1 && (
                <span className="text-[#4A4A4D]/40">|</span>
              )}
            </React.Fragment>
          ))}
        </div>
        <p className="text-[13px] text-[#4A4A4D]">
          © Copyright 2026 eebssolutions LTD. All rights reserved. Company Number:
          17161528
        </p>
      </div>
    </footer>
  );
};

export default Footer;
